// extracted by mini-css-extract-plugin
module.exports = {"hidden":"removeBtn_hidden___Vua3","textEmphasis":"removeBtn_textEmphasis__ld7E_","btn":"removeBtn_btn__LlXOO"};